export default __webpack_public_path__ + "static/media/sambe.ce4f6601.jpeg";